import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_TASK_DETAIL_REQUEST = NS + 'FIND_TASK_DETAIL_REQUEST'
export const FIND_TASK_DETAIL_SUCCESS = NS + 'FIND_TASK_DETAIL_SUCCESS'
export const FIND_TASK_DETAIL_ERROR = NS + 'FIND_TASK_DETAIL_ERROR'

export const UPDATE_VALIDATION_MESSAGE_LIST = NS + 'UPDATE_VALIDATION_MESSAGE_LIST'

export const TOGGLE_PROCESS_FLOW_VISIBILITY = NS + 'TOGGLE_PROCESS_FLOW_VISIBILITY'

export const CHANGE_DUE_DATE_REQUEST = NS + 'CHANGE_DUE_DATE_REQUEST'
export const CHANGE_DUE_DATE_SUCCESS = NS + 'CHANGE_DUE_DATE_SUCCESS'
export const CHANGE_DUE_DATE_ERROR = NS + 'CHANGE_DUE_DATE_ERROR'

export const CHANGE_TASK_STATUS_REQUEST = NS + 'CHANGE_TASK_STATUS_REQUEST'
export const CHANGE_TASK_STATUS_SUCCESS = NS + 'CHANGE_TASK_STATUS_SUCCESS'
export const CHANGE_TASK_STATUS_ERROR = NS + 'CHANGE_TASK_STATUS_ERROR'

export const TRIGGER_EVENT_REQUEST = NS + 'TRIGGER_EVENT_REQUEST'
export const TRIGGER_EVENT_SUCCESS = NS + 'TRIGGER_EVENT_SUCCESS'
export const TRIGGER_EVENT_ERROR = NS + 'TRIGGER_EVENT_ERROR'

export const TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK = NS + 'TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK'

export const CLAIM_TASK_REQUEST = NS + 'CLAIM_TASK_REQUEST'
export const CLAIM_TASK_SUCCESS = NS + 'CLAIM_TASK_SUCCESS'
export const CLAIM_TASK_ERROR = NS + 'CLAIM_TASK_ERROR'

export const UN_CLAIM_TASK_REQUEST = NS + 'UN_CLAIM_TASK_REQUEST'
export const UN_CLAIM_TASK_SUCCESS = NS + 'UN_CLAIM_TASK_SUCCESS'
export const UN_CLAIM_TASK_ERROR = NS + 'UN_CLAIM_TASK_ERROR'

export const UPDATE_ASSIGNED_TO_USER_ID_REQUEST = NS + 'UPDATE_ASSIGNED_TO_USER_ID_REQUEST'
export const UPDATE_ASSIGNED_TO_USER_ID_SUCCESS = NS + 'UPDATE_ASSIGNED_TO_USER_ID_SUCCESS'
export const UPDATE_ASSIGNED_TO_USER_ID_ERROR = NS + 'UPDATE_ASSIGNED_TO_USER_ID_ERROR'

export const CHANGE_PROCESS_TASK = NS + 'CHANGE_PROCESS_TASK'



// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/type.js